/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceStatus } from './PriceStatus';
import {
    PriceStatusFromJSON,
    PriceStatusFromJSONTyped,
    PriceStatusToJSON,
    PriceStatusToJSONTyped,
} from './PriceStatus';

/**
 * 
 * @export
 * @interface CreatePriceRowDto
 */
export interface CreatePriceRowDto {
    /**
     * 
     * @type {number}
     * @memberof CreatePriceRowDto
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceRowDto
     */
    priceUnitId: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceRowDto
     */
    rrp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceRowDto
     */
    lp: number;
    /**
     * 
     * @type {PriceStatus}
     * @memberof CreatePriceRowDto
     */
    priceStatus: PriceStatus;
}



/**
 * Check if a given object implements the CreatePriceRowDto interface.
 */
export function instanceOfCreatePriceRowDto(value: object): value is CreatePriceRowDto {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('lp' in value) || value['lp'] === undefined) return false;
    if (!('priceStatus' in value) || value['priceStatus'] === undefined) return false;
    return true;
}

export function CreatePriceRowDtoFromJSON(json: any): CreatePriceRowDto {
    return CreatePriceRowDtoFromJSONTyped(json, false);
}

export function CreatePriceRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePriceRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'priceUnitId': json['priceUnitId'],
        'rrp': json['rrp'] == null ? undefined : json['rrp'],
        'lp': json['lp'],
        'priceStatus': PriceStatusFromJSON(json['priceStatus']),
    };
}

export function CreatePriceRowDtoToJSON(json: any): CreatePriceRowDto {
    return CreatePriceRowDtoToJSONTyped(json, false);
}

export function CreatePriceRowDtoToJSONTyped(value?: CreatePriceRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'priceUnitId': value['priceUnitId'],
        'rrp': value['rrp'],
        'lp': value['lp'],
        'priceStatus': PriceStatusToJSON(value['priceStatus']),
    };
}

